<div class="pagination-on-scroll">
  <ngx-spinner
    bdColor="transparent"
    size="default"
    color="var(--primary-dark)"
    type="ball-spin-clockwise"
    [fullScreen]="false"></ngx-spinner>
</div>
